import { ValidateProperty } from "../../utilities/validate-property";
import { Division } from "../enums/division";
import { RequestCreate } from "../requests/request-create";
import { CreditLineItem } from "./credit-request-lineitem";

export class CreditRequestCreate extends RequestCreate {

        @ValidateProperty({ required: true })
        public dealerId     : string = '';
        @ValidateProperty({ required: true })
        public currencyId : string = '';
        @ValidateProperty({ required: true })
        public division     : Division | undefined = undefined;
        public serviceCenterId : string = '';
        @ValidateProperty({ validateAnyChildren: true })
        public items        : CreditLineItem[] = [];
        public freight      : number = 0.0;
        public tax          : number = 0.0;
        @ValidateProperty({ maxLength: 2000 })
        public note         : string = '';

            
}